

import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";


 
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
 apiKey: "AIzaSyCY4c21w5glQ1pjGt-A8S9TnoztrUfj5Jc",
  authDomain: "laywer-6305f.firebaseapp.com",
  projectId: "laywer-6305f",
  storageBucket: "laywer-6305f.appspot.com",
  messagingSenderId: "906916919500",
  appId: "1:906916919500:web:d6c81f5337450614b1aa69",
  measurementId: "G-YPK3ZHP580"
};
 
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);

  export  {app,auth,database,storage};
  
